<template>
  <div class="attachmentBox">
    <div class="dataTitle">
      <van-icon
        class="hospiyalsArrowLeft"
        style="top: 16px;"
        name="arrow-left"
        @click="onBack"
        v-if="forwardingReport"
      />
      <div class="title">
        <div class="content" @click="toReport" v-if="examReport">检查报告</div>
        <div class="line" v-if="examReport">|</div>
        <div class="content" @click="toPortrait">数字影像</div>
        <div class="line">|</div>
        <div class="content action">附件</div>
        <div class="line" v-if="forwardingReport">|</div>
        <div class="content" @click="toForwarding" v-if="forwardingReport">转发报告</div>
      </div>
    </div>
    <div class="portraitContent">
      <van-collapse v-model="activeNames">
        <van-collapse-item v-if="attachmentArr[1]&&attachmentArr[1].length !== 0 " title="视频" name="1">
          <div class="attachItem" v-for="(item,index) in attachmentArr[1]" :key="index">
            <p class="titles">视频</p>
            <p class="btns" @click="goView(item)">查看</p>
          </div>
        </van-collapse-item>
        <van-collapse-item v-if="attachmentArr[2]&&attachmentArr[2].length !== 0" title="报告" name="2">
            <div class="attachItem" v-for="(item,index) in attachmentArr[2]" :key="index">
              <p class="titles">报告</p>
              <p class="btns" @click="goView(item)">查看</p>
            </div>
        </van-collapse-item>
        <van-collapse-item v-if="attachmentArr[3]&&attachmentArr[3].length !== 0" title="报告原件" name="3">
            <div class="attachItem" v-for="(item,index) in attachmentArr[3]" :key="index">
              <p class="titles">报告原件</p>
              <p class="btns" @click="goView(item)">查看</p>
            </div>
        </van-collapse-item>
        <van-collapse-item v-if="attachmentArr[4]&&attachmentArr[4].length !== 0" title="排版胶片" name="4">
            <div class="attachItem" v-for="(item,index) in attachmentArr[4]" :key="index">
              <p class="titles">排版胶片</p>
              <p class="btns" @click="goView(item)">查看</p>
            </div>
        </van-collapse-item>
      </van-collapse>
      
      <!-- <div v-else class="white_title">暂无附件</div> -->
    </div>
    <div class="inspectionMontmorillonite" v-if="Montmorillonite">
      <div class="inspectionInputBox">
        <div class="inspectionInputBoxPrompt">提示</div>
        <div class="inspectionInputBoxContent">
          <div class="inspectionInputBoxContentTitle">请输入4位密码查看{{xxx}}的检查报告</div>
          <div class="inspectionInputBoxContentPassword">
            输入密码：
            <input v-model="code" type="text" />
          </div>
        </div>
        <div class="inspectionInputBoxButton">
          <span @click="cencelMontmorillonite">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAttachment,getField } from "@/api/report";
import { getReportByCode } from "@/api/report";
import Storage from "@/tools/storage";
import getQueryString from "@/tools/getUrlParams";
import axios from 'axios'
export default {
  name: "attachment",
  data() {
    return {
      xxx: Storage.get("makeReportLinkName"),
      src: "",
      code: "",
      examReport: true,
      forwardingReport: true,
      examId: true,
      Montmorillonite: false,
      attachmentArr: {},
      activeNames: [''],
      Montmorillonite: false,
    };
  },
  methods: {
    toReport() {
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        if(url.indexOf("service=1") != -1) {
          window.location.href = hostname[0]+'/#/reportInfo/reportStemp?'+ Storage.get("reportParams")
        }else {
          window.location.href = hostname[0]+'/#/reportInfo/report?'+ Storage.get("reportParams")
        }
      }else{
        this.$router.push({ path: "/reportInfo/report"})
      }
    },
    onBack() {
      this.$router.go(-1);
    },
    toPortrait() {
      // this.$router.push({ path: '/reportInfo/portrait' })
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/portrait?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/portrait"})
      }
    },
    toForwarding() {
      // this.$router.push({ path: "/reportInfo/forwarding" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/forwarding?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/forwarding"})
      }
		},
		goView(item) {
      this.$router.push({ path: "/reportInfo/image" ,query: { url: item.url, name: item.name, code: item.annex_class_code}});
    },
    async cencelMontmorillonite() {
      let params = { id: Storage.get("makeReportLinkId"), code: this.code };
      let res = await getReportByCode(params);
      if (res == null) {
        Storage.set("isShows", 1);
      } else {
        Storage.set("reportInfo", res);
        if (res.study_id) {
          Storage.set("studyId", res.study_id);
        } else {
          Storage.set("studyId", res[0].study_id);
        }
        Storage.set("isShows", 2);
        this.Montmorillonite = false;

      }
    },
    async getField(institution_id) {
      let params = {institution_id: institution_id}
      let res = await getField(params);
      if(res){
        this.getAttachment(res)
      }
      // axios.post('http://risserver3.pacsonline.cn/butt/getField',{params:JSON.stringify(params)}).then(res=>{
      //   this.getAttachment(res.data.data)
      // }).catch(function (error) {
      //   alert(error);
      // })
    },
    async getAttachment(names) {
      let reportInfo = JSON.parse(Storage.get("reportInfo"))[0]
      let code = ""
      if(names instanceof Array) {
        code = ""
      }else{
        code = reportInfo[names]
      }
      let params = {
        exam_id: reportInfo.exam_id, 
        exam_datetime:reportInfo.exam_datetime,
        code
      }
      // let examId = JSON.parse(Storage.get("reportInfo"))[0].exam_id
      let res = await getAttachment(params);
      if (res) {
        this.attachmentArr = res
        console.log(res)
        // this.attachmentArr = res.map((item)=>{
        //     return {
        //       ...item,
        //       name: this.getName(item.annex_class_code),
        //       code: item.annex_class_code
        //     }
        // })
      }
    },

    getName(value) {
      if(value == 1){
        return '视频'
      }else if(value == 2){
        return '报告'
      }else if(value == 3){
        return '报告原件'
      }else if(value == 4){
        return '排版胶片'
      }
    }
  },
  created() {
    let institution_id = JSON.parse(Storage.get("reportInfo"))?JSON.parse(Storage.get("reportInfo"))[0].institution_id:''
    institution_id && this.getField(institution_id)
    let url = window.location.href;
    // this.handleChange()
    if (url.indexOf("report_id=") != -1) {
      let openid = getQueryString("openid");
      let examId = getQueryString("exam_id");
      let reportId = getQueryString("report_id");
      Storage.set("openid", openid);
      Storage.set("reportId", reportId);
      Storage.set("examId", examId);
      // this.wechatLogin()
      this.getOneReport();
      return;
    }
    if (url.indexOf("short=1") != -1 || url.indexOf("smslink=1") != -1) {
      if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
        let str = url.match(/id=(\S*)&short/)[1];
        Storage.set("makeReportLinkId", str);
        let string = url.indexOf("name=");
        let names = url.substring(string);
        let num = names.indexOf("=");
        let name = names.substring(num + 1);
        this.xxx = decodeURI(name) + "的";
        Storage.set("makeReportLinkName", decodeURI(name));
      } else if (url.indexOf("smslink=1") != -1 && url.indexOf("id=") != -1) {
        if (url.indexOf("?") != -1) {
          Storage.set("reportParams", url.split('?')[1]);
        }
        Storage.set("makeReportLinkId", this.$route.query.id);
        this.xxx = "";
      }
      if (Storage.get("isShows") == 1 || Storage.get("isShows") == null) {
        this.Montmorillonite = true;
      } else {
        this.Montmorillonite = false;
      }
      Storage.set("reportPermissions", 1);
    } else {
      this.Montmorillonite = false;
      let examId = JSON.parse(Storage.get("reportInfo"));
      let exam_id = examId ? examId[0].exam_id : Storage.get("examId");
      if (exam_id) {
        // this.handleChange(exam_id);
      }
    }
    if (Storage.get("reportPermissions") && getQueryString("id") != 'cnb518tkh0ou8lx9') {
      this.forwardingReport = false;
    }
  },
  mounted() {
   
  }
};
</script>
<style lang="scss" scoped>
.portraitContent {
  padding-top: 55px;
  background: #fff;
  text-align: left;
  font-weight: 600;
  .white_title {
    height: calc(100vh - 55px);
    line-height: calc(100vh - 55px);
    font-size: 20px;
    text-align: center;
  }
  .attachItem{
		border-bottom: 1px solid rgba(231,234,243,.7);
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 0;
		font-size: 16px;
    p{
      margin: 12px 0;
    }
		.titles{
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
		}
		.btns{
      width: 50px;
      margin-left: 15px;
			color: rgb(20, 172, 193);
		}
  }
  .attachItem:nth-last-child(1){
    border-bottom: none;
  }
}
</style>

